import { withStyles } from '@material-ui/core';
import CustomCard from './CustomCard';
import styles from './styles';


export default withStyles(styles)(CustomCard);
